import {  Component,  Injector,  OnInit} from '@angular/core';
import { JackBaseComponentModule,MaterialModule,PageKind, UiModeType, } from 'jk-service';
import { jkSingleComponent,AdvComModule } from 'jk-advcom';
import { Syssh, } from '../_entity_sys';
import { SysshService,  } from '../_service_sys';
import { SysshEditComponent, } from '../_edit_sys';


@Component({
  selector: 'app-syspi84',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    AdvComModule,
    //SysshEditComponent,
  ],
  templateUrl: './syspi84Pkg.component.html',
  styleUrls: [],
})
export class Syspi84Component extends jkSingleComponent implements OnInit {
  override _programId = 'syspi84';
  override masterSrv: SysshService = new SysshService();
  override get srv(): SysshService {
    return this.masterSrv;
  }
  constructor(injector: Injector) {
    super();
    this.uiMode=  UiModeType.dialog;
    this.title = '系統說明建立作業';
    this.gridInitOpt = {programId:this.programId,sortField:'SH001',sort: 'asc',defaultSort: null,pageKind: PageKind.master};
    this.qbeConfig.addField = '';
    this.qbeConfig.addWhere = '';
    this.masterEditPage = SysshEditComponent;


    // this.constructorInit();
  }

  override async constructorInit() {
    await super.constructorInit();
    this.masterSrv.cdr = this.cdr;
  };



}
